import { LightMode, Tag, useColorModeValue, type TagProps } from '@chakra-ui/react';

/** Fixed width so Admin, Spectator, and Latecomer align everywhere (sized to fit "Latecomer"). */
export const LEAGUE_MEMBER_TAG_WIDTH = '5.25rem';

const leagueMemberTagLayoutProps: TagProps = {
  size: 'sm',
  flexShrink: 0,
  w: LEAGUE_MEMBER_TAG_WIDTH,
  minW: LEAGUE_MEMBER_TAG_WIDTH,
  justifyContent: 'center',
};

export type LeagueMemberTagProps = Pick<TagProps, 'fontSize'> & {
  /** League list rows only — tag fits label; leaderboard keeps fixed width. */
  compact?: boolean;
};

export function AdminTag({ fontSize = 'xs', compact = false }: LeagueMemberTagProps = {}) {
  const layout = compact
    ? { size: 'sm' as const, flexShrink: 0, px: 2 }
    : leagueMemberTagLayoutProps;

  return (
    <Tag {...layout} fontSize={fontSize} colorScheme='purple'>
      Admin
    </Tag>
  );
}

export function SpectatorTag({ fontSize = 'xs', compact = false }: LeagueMemberTagProps = {}) {
  const layout = compact
    ? { size: 'sm' as const, flexShrink: 0, px: 2 }
    : leagueMemberTagLayoutProps;
  const colorScheme = useColorModeValue('blackAlpha', 'whiteAlpha');

  return (
    <LightMode>
      <Tag {...layout} fontSize={fontSize} colorScheme={colorScheme}>
        Spectator
      </Tag>
    </LightMode>
  );
}

export function LatecomerTag({ fontSize = 'xs', compact = false }: LeagueMemberTagProps = {}) {
  const layout = compact
    ? { size: 'sm' as const, flexShrink: 0, px: 2 }
    : leagueMemberTagLayoutProps;
  const colorScheme = useColorModeValue('blackAlpha', 'whiteAlpha');

  return (
    <LightMode>
      <Tag {...layout} fontSize={fontSize} colorScheme={colorScheme}>
        Latecomer
      </Tag>
    </LightMode>
  );
}
